import { configureConsults } from './configureConsults'
import { deleteAllConsults } from './deleteAllConsults'
import { deleteConsultById } from './deleteConsultById'
import { getAllConsults } from './getAllConsults'
import { getChartConsults } from './getChartConsults'
import { getStatsConsult } from './getStatsConsult'

export const consultService = {
  getAllConsults,
  deleteConsultById,
  getChartConsults,
  getStatsConsult,
  deleteAllConsults,
  configureConsults,
}
